import getAsset from '~/helpers/getAsset';
import * as entityId from '../../../../constants/entityIds';

export const addOnData = {
  [entityId.WHOLE_HOME_WIFI]: {
    title: 'Whole-Home Wi-Fi',
    image: {
      alt: 'Whole-Home Wi-Fi',
      src: getAsset('/images/icons/icon-home-wifi.svg'),
      height: '50',
      width: '50',
    },
    description: 'Virtually eliminate dead spots and maximize the Wi-Fi coverage in your home.',
    content: {
      details: [
        {
          text: 'Professional Wi-Fi consultation for your home.',
        },
        {
          text: 'Up to 2 additional mesh Wi-Fi devices to supercharge your coverage.',
        },
      ],
    },
  },
  [entityId.UNBREAKABLE_WIFI]: {
    title: 'Unbreakable<sup>&trade;</sup> Wi-Fi',
    image: {
      alt: 'Unbreakable™ Wi-Fi',
      src: getAsset('/images/icons/icon-wifi-lock.svg'),
      height: '50',
      width: '50',
    },
    description: 'Stay connected with backup internet that automatically turns on if your connection goes down.',
    content: {
      details: [
        {
          text: 'Simple, one-time setup.',
        },
        {
          text: 'Automatic Switchover: Switches your internet connection so your devices stay connected.',
        },
        {
          text: 'Stay online with a backup connection during network outages.',
        },
      ],
    },
  },
  [entityId.WHOLE_HOME_WIFI_PLUS]: {
    title: 'Whole-Home Wi-Fi Plus',
    image: {
      alt: 'Whole-Home Wi-Fi Plus',
      src: getAsset('/images/icons/icon-wifi-lock.svg'),
      height: '50',
      width: '50',
    },
    description: 'Unlock the power of Wi-Fi 7 for your whole home, plus get complete online security for everywhere you are—at home and on the go.',
    content: {
      details: [
        {
          text: 'Get 2 premium eero Max 7 devices with Wi-Fi 7—the best Wi-Fi available,',
        },
        {
          text: 'Protect all your connected devices at home, or up to 3 devices on public Wi-Fi with Malwarebytes',
        },
        {
          text: 'Shield your online identity on up to 5 devices with Guardian VPN for mac, iOS, and Android',
          tooltip: 'VPN powered by Guardian works only with devices running macOS, iOS, or Android.',
        },
        {
          text: 'Securely store and manage your passwords with 1Password',
        },
        {
          text: 'Use advanced parental tools like Wi-Fi controls, time limits and website blocking. Enjoy ad-free browsing to block unwanted, intrusive marketing',
        },
      ],
    },
  },
  [entityId.WIFI_SECURITY]: {
    title: 'Wi-Fi Security',
    description:
      "If it's connected, you're protected. Wi-Fi Security helps defend your home network from online threats.",
    content: {
      contentImage: {
        alt: 'Wi-Fi Security',
        src: getAsset('/images/product-selection/wifi-security-phone.png'),
        width: '200',
        className: 'wifi-security',
      },
      details: [
        {
          text: 'Wi-Fi controls and ad-free browsing',
        },
        {
          text: 'Advanced parental tools such as time limits and website blocking',
        },
        {
          text: 'Device security to prevent accidental visits to malicious sites',
        },
      ],
    },
  },
  [entityId.YTTV_BASIC]: {
    image: {
      alt: 'YouTube TV',
      src: getAsset('/images/logos/yttv-logo.svg'),
      width: '200',
    },
    description:
      'YouTube TV is a better way to get your favorite channels for one low, all-in monthly price. Watch 100+ channels of live sports, breaking news, and must-see shows and movies.',
    content: {
      details: [
        {
          bold: 'Special savings',
          text: 'Frontier customers new to YouTube TV can get a special 12-month price.  Free trial. No contract or equipment fees. Cancel anytime.',
        },
        {
          bold: 'Free DVR recording',
          text: 'Record your favorites for free with unlimited cloud storage—no cable box needed. Get up to 6 accounts to share with your household.',
        },
        {
          bold: 'One convenient bill',
          text: 'Keep it simple with one bill for your YouTube TV subscription and Frontier services.',
        },
      ],
    },
  },
  [entityId.UNLIMITED_VOICE]: {
    title: 'Unlimited Digital Voice',
    image: {
      alt: 'Unlimited Digital Voice',
      src: getAsset('/images/icons/icon-phone-red.svg'),
      height: '50',
      width: '50',
    },
    description: 'Adding a home phone can help bring you and your family peace of mind.',
    content: {
      details: [
        {
          bold: 'Clear call quality',
          text: 'Get clear call quality day and night so you can have better conversations without worrying about dropped calls.',
        },
        {
          bold: 'Helpful call management features like Caller ID, Call Waiting, and Voicemail',
          text: 'Whether you’re calling into work meetings from the comfort of your home or you’re looking to save minutes on your cell phone plan, adding a home phone can help bring you and your family peace of mind.',
        },
        {
          bold: 'Unlimited nationwide & long-distance calling',
          text: 'Stay in touch with your far away loved ones through unlimited minutes.',
        },
        {
          bold: 'Transferring or setting up your phone number',
          text: 'We can provide a new telephone number, or you can transfer your current number if it meets our geographic requirements.',
        },
      ],
    },
  },
  [entityId.TOTAL_SHIELD]: {
    title: 'Total Shield',
    image: {
      alt: 'Total Shield',
      src: getAsset('/images/icons/icon-computer.svg'),
      height: '50',
      width: '50',
    },
    description: 'Protect your entire online experience with three security features in a custom app.',
    content: {
      details: [
        {
          bold: 'Multi-Device Security',
          text: 'Keep your devices free of viruses and malware with browsing protection, family rules and banking protection.',
        },
        {
          bold: 'VPN Privacy',
          text: 'VPN masks your IP and safeguards your online identity, whether you’re home or away, so you can use public Wi-Fi safely.',
        },
        {
          bold: 'Password Manager',
          text: 'Eliminate the need to remember multiple passwords. Auto-generate and auto-fill login information with just one click.',
        },
      ],
    },
  },
  [entityId.IDENTITY_PROTECTION]: {
    title: 'Identity Protection',
    image: {
      alt: 'Identity Protection',
      src: getAsset('/images/icons/icon-lock.svg'),
      height: '32',
      width: '44',
    },
    description: 'Don’t become a statistic. Secure your online data with personal information monitoring.',
    content: {
      details: [
        {
          text: 'Triple-bureau credit monitoring quickly alerts you to changes in your credit report',
        },
        {
          text: 'Monitors Social Security Number, Global ID, debit/credit cards, and more',
        },
        {
          text: 'Lost wallet services with support to cancel and reissue lost or stolen information',
        },
        {
          text: 'Identity restoration services, up to $1,000,000 in coverage',
        },
      ],
    },
  },
  [entityId.MY_PREMIUM_TECH_PRO]: {
    title: 'My Premium Tech Pro',
    image: {
      alt: 'My Premium Tech Pro',
      src: getAsset('/images/icons/icon-headset.svg'),
      height: '50',
      width: '50',
    },
    description:
      'Whatever is the issue, My Premium Tech Pro helps ensure your home tech is always working for you. And with tech experts available 7 am to midnight ET, 365 days a year, help is always here when you need it.',
    content: {
      details: [
        {
          bold: 'Home',
          text: 'Device selection and setup, smart speakers, DIY home security, home theater and smart appliances',
        },
        {
          bold: 'Hardware',
          text: 'Desktops and laptops, printers, modems and routers, peripherals and smart phones',
        },
        {
          bold: 'Network',
          text: 'Cloud services and backup, Wi-Fi and internet, wireless configurations, streaming and Bluetooth',
        },
        {
          bold: 'Online',
          text: 'Social media, e-commerce, iTunes, email and calendar sync and security apps',
        },
      ],
    },
  },
  [entityId.WIFI_SECURITY_PLUS]: {
    title: 'Wi-Fi Security Plus',
    description:
      'Get all the features from Wi-Fi Security, plus a suite of premium software to help protect yourself from online attacks.',
    isDetailsTextBold: false,
    isCheckMarkVisible: false,
    content: {
      details: [
        {
          bold: 'Malwarebytes anti-virus software',
          text: 'Award-winning antivirus software that helps protect your devices from malware, hackers and other online threats.',
        },
        {
          bold: '1Password password manager',
          text: 'Store your passwords, account credentials and other sensitive information in a secure system.',
        },
        {
          bold: 'Guardian VPN Protection',
          text: 'A VPN masks your IP address and encrypts your data when you use the internet, making your experience safer and more private.',
          tooltip: 'VPN powered by Guardian works only with devices running macOS, iOS, or Android.',
        },
      ],
    },
  },
  [entityId.NETFLIX_BUNDLE]: {
    title: 'Netflix & Pro Wi-Fi Bundle',
    image: {
      alt: 'Netflix & Pro Wi-Fi Bundle',
      src: getAsset('/images/icons/icon-netflix.svg'),
      height: '50',
      width: '50',
    },
    description: 'Get powerful and secure Wi-Fi throughout your home, plus Netflix Premium.',
    isDescriptionCentered: true,
    isDetailsTextBold: false,
    isDetailsSameLine: true,
    content: {
      details: [
        {
          bold: 'Pro Wi-Fi',
          text: 'Experience powerful and secure Wi-Fi throughout your home with Whole-Home Wi-Fi and Wi-Fi Security.',
        },
        {
          bold: 'Netflix Premium',
          text: 'Movies, series, and games for the whole family. Watch ad-free in Ultra HD 4K on up to 4 devices and download on 6 devices.',
        },
        {
          bold: 'All-in-one savings',
          text: 'Bundle our top two Wi-Fi services and Netflix Premium in one bill. Save $95 annually.',
        },
      ],
    },
  },
};
